<template>
  <stage-card-info-list>
    <template #header>Recommendation</template>
    <template #content>
      <screening-advice-status-item :state="adviceState" small />
      <div class="caption">
        After 40 consecutive Not Relevant screens &amp; no estimated
        remaining relevant, we will recommend you to stop screening.
      </div>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import ScreeningAdviceStatusItem from '@/components/ReviewSummary/ScreeningAdviceStatusItem';
import { Review } from '@/models';

export default {
  name: 'ScreeningRecommendation',
  components: {
    StageCardInfoList,
    ScreeningAdviceStatusItem,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    adviceState() {
      return this.review.screeningAdviceState();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.caption {
  color: map-get($grey, 'base');
}
</style>
